import { createFileRoute } from "@tanstack/react-router";
import type { Id } from "@convex/_generated/dataModel";
import { LeagueOverview } from "@/features/leagues/components/LeagueOverview";
import { PageContainer } from "@/shared/layout/PageContainer";

export const Route = createFileRoute("/_authenticated/leagues/$leagueId/")({
  component: LeagueDashboardPage,
});

function LeagueDashboardPage() {
  const { leagueId } = Route.useParams();
  return (
    <PageContainer>
      <LeagueOverview leagueId={leagueId as Id<"leagues">} />
    </PageContainer>
  );
}
